// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // BASE_URL: 'https://localhost:4200/',
  // API_URL: 'https://api-dev.hubbubhr.com/',
  // AUTHENICATION_URL: 'https://auroraoauth.azurewebsites.net/',
  // TENANT_ID: '3BF0F154-E714-48F8-BB34-486FE1EB167C',
  // CLIENT: 'angular-wtf',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
